import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const DELETE_STATEMENT_INTERESTS_HOLD = gql`
  mutation DeleteStatementInterestsHold($uuid: ID!) {
    deleteStatementInterestsHold(uuid: $uuid)
  }
`;

export const useDeleteStatementInterestsHold = () => {
  const [deleteStatementInterestsHold, { loading, error, data }] = useMutation(DELETE_STATEMENT_INTERESTS_HOLD);

  return {
    deleteStatementInterestsHold,
    loading,
    error,
    data: data?.deleteStatementInterestsHold,
  };
};

export default useDeleteStatementInterestsHold;
